'use client';

import { useMutation } from '@apollo/client/react';
import { REMOVE_FAVOURITE_RECIPE } from '@fdc/federation/nz/mutations/remove-favourite-recipe';

export const useRemoveFavouriteRecipe = () => {
  const [removeFavouriteRecipe, { loading, error }] = useMutation(
    REMOVE_FAVOURITE_RECIPE
  );

  const handleRemoveFavouriteRecipe = (recipeId: string) => {
    return removeFavouriteRecipe({
      variables: {
        input: { recipeId },
      },
    });
  };

  return {
    handleRemoveFavouriteRecipe,
    loading,
    error,
  };
};
